export interface IRoundDates {
    round_type: string;
    round_date_status: string;
    round_date: (Date | null)[];
}

export const RoundTypes = [
    // { label: 'Group Discussion', value: 'group_discussion' },
    // { label: 'Machine Test', value: 'machine_test' },
    // { label: 'Pre-Placement Talk', value: 'pre_placement_talk' }
    { label: 'Online Screening/Aptitude Test', value: 'online_screening', isActive: false },
    { label: 'Group Discussion', value: 'group_discussion', isActive: false },
    { label: 'Technical Coding', value: 'technical_coding', isActive: false },
    { label: 'Technical Interview', value: 'technical_interview', isActive: false },
    { label: 'HR Interview', value: 'hr_interview', isActive: false }
];

export const RoundOptions = [
    { label: 'All', value: 'all', isActive: true },
    { label: 'Online Screening/Aptitude Test', value: 'online_screening', isActive: false },
    { label: 'Group Discussion', value: 'group_discussion', isActive: false },
    { label: 'Technical Coding', value: 'technical_coding', isActive: false },
    { label: 'Technical Interview', value: 'technical_interview', isActive: false },
    { label: 'HR Interview', value: 'hr_interview', isActive: false },
    { label: 'Event', value: 'event', isActive: false }
]

export const roundColors: { [key: string]: string } = {
    "online_screening": "rgb(129, 199, 132)", // Green
    "group_discussion": "rgb(79, 195, 247)", // Sky blue
    "technical_coding": "rgb(255, 183, 77)", // Orange
    "technical_interview": "rgb(240, 98, 146)", // Pink
    "hr_interview": "rgb(186, 104, 200)", // Purple
    "event": "rgb(77, 208, 225)" // Cyan
}